import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Label, Row, Col, Table, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField, AvFeedback } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import * as moment from 'moment';

import { IRootState } from 'app/shared/reducers';
import { createEntity, payByCash, payByAsiaPay } from 'app/entities/payment/payment.reducer';
import OrderBreadCrumb from '../order-breadcrumb';
import SeatPlanModal from 'app/modules/seat-plan/seat-plan-modal';
import { defaultEventTypes, EventTypes, IEvent, IEventTypes } from 'app/shared/model/event.model';
import { genTransactionTable, isIgnoreZoneSeat } from '../order-shared';
import { ASIAPAY_URL, ASIAPAY_MERCHANT_ID, APP_LOCAL_DATE_FOR_PROMOTION } from 'app/config/constants';

export interface IPaymentInfoProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IPaymentInfoState {
  event: IEvent;
  showModal: boolean;
  tickets: any[];
  zoneName: string;
  pi: { lastName: string; firstName: string; email: string; address: string; mobile: string; declineEmailPromo: boolean };
  paymentMethod: 'JETCO' | 'CASH' | 'ASIA_PAY';
}

export class PaymentInfo extends React.Component<IPaymentInfoProps, IPaymentInfoState> {
  state: IPaymentInfoState = {
    event: {},
    pi: { lastName: '', firstName: '', email: '', address: '', mobile: '', declineEmailPromo: false },
    showModal: false,
    tickets: [],
    zoneName: '',
    paymentMethod: 'ASIA_PAY'
  };

  creditCardForm: any;

  constructor(props) {
    super(props);
    this.creditCardForm = React.createRef();
  }

  componentDidMount() {
    const pi = Storage.session.get('PI');
    if (pi) this.setState({ pi });

    const event = Storage.session.get('EVENT');
    if (event != null) {
      this.setState({ event });
    }
  }

  componentDidUpdate() {
    if (this.state.paymentMethod === 'JETCO' && this.props.digitalOrder) this.creditCardForm.submit();
    if (this.state.paymentMethod === 'ASIA_PAY' && this.props.invoiceNo) {
      const transaction = Storage.session.get('TRANSACTION');
      transaction.invoiceNo = this.props.invoiceNo;
      Storage.session.set('TRANSACTION', transaction);
      this.creditCardForm.submit();
    }
  }

  submitForm = (event, values) => {
    const { pi } = this.state;
    const transaction = Storage.session.get('TRANSACTION');
    // if (Object.keys(transaction).length === 0) transaction = Storage.session.get('TRANSACTION');
    const orderToken = Storage.session.get('ORDER_TOKEN');
    const entity = {
      transactionId: transaction.id,
      cardNo: values.cardNo,
      expiryDate: values.expiryMonth && values.expiryYear ? values.expiryMonth + values.expiryYear.substring(2, 4) : '9999',
      cvv: values.cvv ? values.cvv : '999',
      firstName: pi.firstName,
      lastName: pi.lastName,
      mobile: pi.mobile,
      address: pi.address,
      email: pi.email,
      declineEmailPromo: pi.declineEmailPromo,
      token: orderToken ? orderToken.token : ''
    };
    if (values.answer1) {
      entity['question1'] = translate('order.paymentinfo.question1');
      entity['answer1'] = values.answer1;
    }
    if (values.answer2) {
      entity['question2'] = translate('order.paymentinfo.question2');
      entity['answer2'] = values.answer2;
    }
    if (values.answer3) {
      entity['question3'] = translate('order.paymentinfo.question3');
      entity['answer3'] = values.answer3;
    }
    if (this.state.paymentMethod === 'JETCO') this.props.createEntity(entity);
    else if (this.state.paymentMethod === 'ASIA_PAY') {
      this.props.payByAsiaPay(entity);
    } else {
      this.props.payByCash(entity);
    }
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  onPreviewClick = (tickets, zoneName) => {
    this.setState({ tickets, zoneName, showModal: true });
  };

  renderSecurityQuestions = () => (
    <>
      <Row className="justify-content-center mt-4">
        <Col md="12" className="text-center bg-primary">
          <h2 className="mt-3 mb-3 text-light">
            <Translate contentKey="order.paymentinfo.securiyquestion">Answer 3 Security Questions</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center mt-4  p-2">
        <Col xs="8">
          <Row>
            <Col md="6" xs="12" className="text-md-right">
              <Label for="a1">
                <Translate contentKey="order.paymentinfo.question1">What is the name of your first pet</Translate>
              </Label>
            </Col>
            <Col md="6" xs="12">
              <AvField
                type="text"
                name="answer1"
                validate={{
                  required: {
                    value: true,
                    errorMessage: translate('entity.validation.required')
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="12" className="text-md-right">
              <Label for="a1">
                <Translate contentKey="order.paymentinfo.question2">What is your dream job</Translate>
              </Label>
            </Col>
            <Col md="6" xs="12">
              <AvField
                type="text"
                name="answer2"
                validate={{
                  required: {
                    value: true,
                    errorMessage: translate('entity.validation.required')
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="12" className="text-md-right">
              <Label for="a1">
                <Translate contentKey="order.paymentinfo.question3">What is your favourite singer or band</Translate>
              </Label>
            </Col>
            <Col md="6" xs="12">
              <AvField
                type="text"
                name="answer3"
                validate={{
                  required: {
                    value: true,
                    errorMessage: translate('entity.validation.required')
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-3 text-center">
        <Col md="12" xs="12">
          <p>
            *<Translate contentKey="order.paymentinfo.note1">3 questions are used for security check</Translate>
          </p>
        </Col>
      </Row>
    </>
  );

  renderCreditCardForm = () => {
    const currentYear = moment().year();
    const MAX_YEAR = 10;
    const yearOptions = [];
    for (let i = 0; i < MAX_YEAR; i++) {
      yearOptions.push(currentYear + i + '');
    }
    return (
      <>
        <Row className="justify-content-center mt-4">
          <Col md="12" className="text-center bg-primary">
            <h2 className="mt-3 mb-3 text-light">
              <Translate contentKey="order.paymentinfo.carddetails">Fill in Card Details</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center mt-4 p-2">
          {/*          <Col md="8">
            <Row className="px-4">
              <Translate contentKey="order.paymentinfo.cardnote1">Card Note 1</Translate>
            </Row>
          </Col>*/}
          <Col md="6">
            <Row className="mt-3">
              <Col md="4" xs="4" className="text-right">
                <Label for="lastName">
                  <Translate contentKey="order.paymentinfo.cardno">Card Number</Translate>
                </Label>
              </Col>
              <Col md="8" xs="8">
                <AvField
                  type="text"
                  name="cardNo"
                  placeholder={translate('order.paymentinfo.cardno')}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: translate('entity.validation.required')
                    },
                    pattern: {
                      value:
                        '^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|' +
                        '3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\\d{3})\\d{11})$',
                      errorMessage: translate('global.messages.validate.card.invalid')
                    }
                  }}
                  // value="4557071000697805"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="4" xs="4" className="text-right">
                <Label for="firstName">
                  <Translate contentKey="order.paymentinfo.expirydate">Expiry Date</Translate>
                </Label>
              </Col>
              <Col md="3" xs="3">
                <AvField
                  type="select"
                  name="expiryMonth"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: translate('entity.validation.required')
                    }
                  }}
                  value="12"
                >
                  <option value="">mm</option>
                  <option>01</option>
                  <option>02</option>
                  <option>03</option>
                  <option>04</option>
                  <option>05</option>
                  <option>06</option>
                  <option>07</option>
                  <option>08</option>
                  <option>09</option>
                  <option>10</option>
                  <option>11</option>
                  <option>12</option>
                </AvField>
              </Col>
              <Col md="1" xs="1" className="mt-1 text-center">
                /
              </Col>
              <Col md="3" xs="4">
                <AvField
                  type="select"
                  name="expiryYear"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: translate('entity.validation.required')
                    }
                  }}
                  value="2030"
                >
                  <option value="">yy</option>
                  {yearOptions.map(o => <option key={o}>{o}</option>)}
                </AvField>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="4" xs="4" className="text-right">
                <Label for="email">
                  <Translate contentKey="order.paymentinfo.cvv">cvv</Translate>
                </Label>
              </Col>
              <Col md="4" xs="4">
                <AvField
                  type="number"
                  name="cvv"
                  placeholder="驗証號碼"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: translate('entity.validation.required')
                    },
                    pattern: {
                      value: '^[0-9]{3}$',
                      errorMessage: translate('global.messages.validate.verificationCode.invalid')
                    }
                  }}
                  value="999"
                />
              </Col>
            </Row>
            <Row>
              <Col md="12" className="text-center mt-4 mb-4">
                <Button color="primary" size="xlg" disabled={this.props.updating}>
                  <Translate contentKey="order.paymentinfo.confirmpay">Confirm and Pay</Translate>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    );
  };

  renderAsiaPayForm = () => (
    <>
      {/*<Row className="justify-content-center mt-4">
        <Col md="12" className="text-center bg-primary">
          <h2 className="mt-3 mb-3 text-light">
            <Translate contentKey="order.paymentinfo.asiapaynote">支援以下付款方式</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center mt-4 p-2">
        <Col md="6">
          <Row className="px-4">
            <img src="static/images/payments.png" className="img-fluid" />
          </Row>
        </Col>
      </Row>*/}
      <Row>
        <Col md="12" className="text-center mt-4 mb-4">
          <Button color="primary" size="xlg" disabled={this.props.updating}>
            <Translate contentKey="order.paymentinfo.gopay">前往付款</Translate>
          </Button>
        </Col>
      </Row>
    </>
  );

  getCardType = cardNo => {
    const re = new RegExp('^4');
    if (cardNo.match(re) != null) return 'VISA';

    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(cardNo)) return 'Master';

    // re = new RegExp("^3[47]");
    // if (cardNo.match(re) != null) return "AMEX";

    return '';
  };

  renderCashForm = () => (
    <>
      <Row className="justify-content-center mt-4">
        <Col md="12" className="text-center bg-primary">
          <h2 className="mt-3 mb-3 text-light">
            <Translate contentKey="order.paymentinfo.cashdetails">暫時只支援使用FPS/PAYME付款</Translate>
          </h2>
        </Col>
      </Row>
      <p className="text-center mt-4">
        <h3>FPS ID: 105988885</h3>
        <h3>PATO ENTERTAINMENT LIMITED</h3>
        <img className="img-fluid payme-qr" src="static/images/payme-qr.jpg" alt="payme" />
      </p>
      <p className="text-center mt-4">
        <h3>滙豐銀行: (004) 801-618646-838</h3>
      </p>
      <p className="text-center mt-4">
        <Translate contentKey="order.paymentinfo.cashnote1">
          付款後請將付款截圖連同交易編號發送到<a href="mailto:cs@patotix.com">cs@patotix.com</a>
          或 WhatsApp{' '}
          <a href="https://wa.me/+85256676376" target="_blank">
            (852) 5667 6376
          </a>
        </Translate>
      </p>
      {!this.props.invoiceNo && (
        <Row>
          <Col md="12" className="text-center mt-4 mb-4">
            <Button color="primary" size="xlg" disabled={this.props.updating}>
              <Translate contentKey="order.paymentinfo.confirmorder">確認訂單</Translate>
            </Button>
          </Col>
        </Row>
      )}
    </>
  );

  render() {
    const promotionCodeSuffix = moment().format(APP_LOCAL_DATE_FOR_PROMOTION);
    const { event, pi } = this.state;
    // get transaction first. If empty, get from storage
    const transaction = Storage.session.get('TRANSACTION');
    const hostOrigin = window.location.origin;
    // if (Object.keys(transaction).length === 0) transaction = Storage.session.get('TRANSACTION');
    let isShowSecurityQ = true;
    let eventTypes: IEventTypes = {};
    if (event.types && event.types !== '') {
      eventTypes = event.types && event.types !== '' ? JSON.parse(event.types) : defaultEventTypes;
      if (eventTypes.type !== EventTypes.TICKET_DELIVERY || eventTypes.type !== EventTypes.COLLECTION_AT_SHOW) {
        isShowSecurityQ = false;
      }
    }

    return (
      <Row className="justify-content-center">
        <SeatPlanModal
          showModal={this.state.showModal}
          handleClose={this.handleClose}
          tickets={this.state.tickets}
          zoneName={this.state.zoneName}
        />
        <Col md="8" className="bg-white">
          <OrderBreadCrumb step="4" currentLocale={this.props.currentLocale} />
          <Row className="justify-content-center mt-3">
            <Col md="12" className="text-center mt-3">
              {genTransactionTable(transaction, this.onPreviewClick, isIgnoreZoneSeat(event))}
            </Col>
          </Row>
          <Row className="justify-content-center mt-4">
            <Col md="12" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.paymentinfo.pi">Personal Info</Translate>
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 p-2">
            <Col md="8">
              <Row>
                <Col md="4" xs="4" className="text-right">
                  <p>
                    <Translate contentKey="order.paymentinfo.lastname">Last Name</Translate>
                  </p>
                </Col>
                <Col md="8" xs="8">
                  <p>{pi.lastName}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="4" xs="4" className="text-right">
                  <p>
                    <Translate contentKey="order.paymentinfo.firstname">First Name</Translate>
                  </p>
                </Col>
                <Col md="8" xs="8">
                  <p>{pi.firstName}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="4" xs="4" className="text-right">
                  <p>
                    <Translate contentKey="order.paymentinfo.email">Email</Translate>
                  </p>
                </Col>
                <Col md="8" xs="8">
                  <p>{pi.email}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="4" xs="4" className="text-right pl-0">
                  <p>
                    {eventTypes.labelOverrideAddress ? (
                      eventTypes.labelOverrideAddress
                    ) : (
                      <Translate contentKey="order.paymentinfo.address">Address</Translate>
                    )}
                  </p>
                </Col>
                <Col md="8" xs="8">
                  <p>{pi.address}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="4" xs="4" className="text-right">
                  <p>
                    <Translate contentKey="order.paymentinfo.mobile">Mobile</Translate>
                  </p>
                </Col>
                <Col md="8" xs="8">
                  <p>{pi.mobile}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          <AvForm onValidSubmit={this.submitForm}>
            {isShowSecurityQ && this.renderSecurityQuestions()}
            {this.state.paymentMethod === 'JETCO' && this.renderCreditCardForm()}
            {this.state.paymentMethod === 'ASIA_PAY' && this.renderAsiaPayForm()}
            {this.state.paymentMethod === 'CASH' && this.renderCashForm()}
          </AvForm>

          {this.state.paymentMethod === 'JETCO' && (
            <form action="https://www.jetcopg.com/PayPage/payPage.jsp" method="POST" ref={form => (this.creditCardForm = form)}>
              <input type="hidden" name="DO" value={this.props.digitalOrder} />
              <Button type="submit" className="d-none" />
            </form>
          )}
          {this.state.paymentMethod === 'ASIA_PAY' && (
            <form
              action={eventTypes.paymentUrl ? eventTypes.paymentUrl : ASIAPAY_URL}
              method="POST"
              ref={form => (this.creditCardForm = form)}
            >
              <input type="hidden" name="merchantId" value={eventTypes.merchantId ? eventTypes.merchantId : ASIAPAY_MERCHANT_ID} />
              <input type="hidden" name="amount" value={transaction.amount} />
              <input type="hidden" name="orderRef" value={this.props.invoiceNo} />
              {eventTypes.promotionCode && (
                <>
                  <input type="hidden" name="promotion" value="T" />
                  <input type="hidden" name="promotionCode" value={eventTypes.promotionCode + promotionCodeSuffix} />
                  {eventTypes.promotionRuleCode && (
                    <input type="hidden" name="promotionRuleCode" value={eventTypes.promotionRuleCode + promotionCodeSuffix} />
                  )}
                </>
              )}
              <input type="hidden" name="currCode" value="344" />
              <input type="hidden" name="payMethod" value="ALL" />
              <input type="hidden" name="payType" value="N" />
              <input type="hidden" name="successUrl" value={hostOrigin + '/#/order/asiapay-result/success'} />
              <input type="hidden" name="failUrl" value={hostOrigin + '/#/order/asiapay-result/failure'} />
              <input type="hidden" name="cancelUrl" value={hostOrigin + '/#/order/asiapay-result/failure'} />
              <input type="hidden" name="lang" value="C" />
              <Button type="submit" className="d-none" />
            </form>
          )}
          {this.state.paymentMethod === 'CASH' &&
            this.props.invoiceNo && (
              <Row className="justify-content-center mt-4 p-2">
                <Col md="8">
                  <p className="text-center">
                    <h2>賬單號碼: {this.props.invoiceNo}</h2>
                    <br />
                    <Translate contentKey="order.paymentresult.cashnote1">
                      閣下於成功付款後，將會收到確認電郵。如有任可疑問，歡迎電郵至<a href="mailto:cs@patotix.com">cs@patotix.com</a>
                      或 WhatsApp{' '}
                      <a href="https://wa.me/+85256676376" target="_blank">
                        (852) 5667 6376
                      </a>{' '}
                      與我們聯絡。
                    </Translate>
                    <br />
                    <br />
                    <Button color="primary" href="/#/" size="xlg" className="mt-4">
                      <Translate contentKey="order.paymentresult.homebutton">返回首頁訂購其他門票</Translate>
                    </Button>
                  </p>
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  transaction: storeState.order.transaction,
  digitalOrder: storeState.payment.digitalOrder,
  invoiceNo: storeState.payment.invoiceNo,
  currentLocale: storeState.locale.currentLocale,
  updating: storeState.payment.updating
});

const mapDispatchToProps = { createEntity, payByCash, payByAsiaPay };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInfo);
